var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRuppeeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 14,
    viewBox: "0 0 11 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.13398 13.4168L5.42169 9.32108C5.23966 9.02983 5.04549 8.79319 4.83918 8.61116C4.64501 8.42912 4.42657 8.3017 4.18386 8.22889C3.94115 8.15607 3.6499 8.11967 3.3101 8.11967H0.707031V6.77262H4.34769C5.31854 6.77262 6.04667 6.57238 6.53209 6.17191C7.01751 5.7593 7.27843 5.16466 7.31483 4.38799L7.58788 4.57002H0.707031V3.42321H7.58788L7.27843 3.64165C7.18134 3.0106 6.89616 2.53732 6.42287 2.22179C5.96172 1.89413 5.3064 1.7303 4.45691 1.7303H0.707031V0.583496H10.8645V1.7303H7.33304L7.64249 1.49366C8.07937 1.72424 8.41917 2.02763 8.66188 2.40383C8.90459 2.78003 9.05628 3.21691 9.11696 3.71446L8.75289 3.42321H10.8645V4.57002H8.8075L9.15337 4.22416C9.17764 5.00083 9.01381 5.67436 8.66188 6.24473C8.32208 6.8151 7.82453 7.25804 7.16921 7.57357C6.52602 7.87696 5.74328 8.02865 4.82098 8.02865V7.84662H5.22145C5.71901 7.84662 6.15589 7.95584 6.53209 8.17428C6.90829 8.39272 7.27843 8.77499 7.64249 9.32108L10.373 13.4168H8.13398Z",
    fill: "#445386"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRuppeeIcon);
export default __webpack_public_path__ + "static/media/ruppeeIcon.71f402411e7788d8a6b2226bedb90006.svg";
export { ForwardRef as ReactComponent };